'use client'

import React from 'react'
import CriticalRecoverScreen from '@/components/CriticalRecoverScreen'

// Комментарий на русском: кастомная страница ошибки (вместо "Application error...").
export default function ErrorPage({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return <CriticalRecoverScreen reset={reset} />
}


